export const tr = {
    'approve-package': 'todo',
    'reject-package': 'Reddet',
    'to-approve': 'todo',
    'to-edit': 'Düzelt'
};
